import { gettext } from '@eb/i18n';

export const SNOWGLOBE = {
    imagePath: 'brand-logos/snow-globe',
    quote: gettext(
        '"Eventbrite just improves every aspect of your festival exponentially."',
    ),
    byline: gettext('Jeffrey Lesan, CMO'),
};

export const GENERAL_ASSEMBLY = {
    imagePath: 'brand-logos/general-assembly',
    quote: gettext(
        '"Eventbrite helped us grow quickly. We were able to ramp up in multiple countries without worrying about international payment."',
    ),
    byline: gettext('Anna Lindow, Campus Education and Operations'),
};

export const MOZCON = {
    imagePath: 'brand-logos/moz',
    quote: gettext(
        '"The amount of time Eventbrite saves me to focus on other things is amazing."',
    ),
    byline: gettext('Danielle Launders, Community Events Manager'),
};

export const CRESCENT_CITY_CLASSIC = {
    imagePath: 'brand-logos/crescent-city',
    quote: gettext(
        '"Not only does Eventbrite make our pages reflect our brand, they also make it really easy for attendees to sign up both online and through mobile."',
    ),
    byline: gettext('Laine Thomas, Event Manager'),
};

export const YMCA = {
    imagePath: 'brand-logos/ymca',
    quote: gettext(
        '"The Eventbrite interface is easy to use. For nonprofits, it’s a great central hub for all your events."',
    ),
    byline: gettext('Lauren Bruce, Campaign Director'),
};

export const WEB_DIRECTIONS = {
    imagePath: 'brand-logos/web-directions',
    quote: gettext(
        '"Eventbrite allows us to \'spin up\' new events quickly, freeing time to focus on the quality of our events, not managing attendees. We love it!"',
    ),
    byline: gettext('John Allsopp, Co-founder'),
};

export const THE_YOGA_EXPO = {
    imagePath: 'brand-logos/yoga-expo',
    quote: gettext(
        '"I get at least 2 emails a day from people who found us through Eventbrite, which is potentially $2,000 - $3,000 in revenue. It\'s incredible."',
    ),
    byline: gettext('Kyle Michaud, Founder'),
};

export const MAKER_FAIRE = {
    imagePath: 'brand-logos/maker-faire',
    quote: gettext(
        '"Not only has Eventbrite helped us figure out how to grow painlessly, but it’s given us a better understanding of where our attendees are coming from and how they’re finding out about our events."',
    ),
    byline: gettext('Sherri Huss, Maker-in-Chief'),
};

export const AWESOME_INC_U = {
    imagePath: 'brand-logos/awesome-inc',
    quote: gettext(
        '"I didn\'t expect our classes to take off as fast as they did. Eventbrite allowed us to turn our passion into a business overnight."',
    ),
    byline: gettext('Nick Such, Founder'),
};

export const DANCE_411 = {
    imagePath: 'brand-logos/dance-411',
    quote: gettext(
        '"If I was starting a dance studio right now, I would tell you that you have to get on Eventbrite to expose yourself to more walk-in traffic."',
    ),
    byline: gettext('Ed Schneider, Co-owner'),
};

export const NATIONAL_SAWDUST = {
    imagePath: 'brand-logos/national-sawdust',
    quote: gettext(
        '"What Eventbrite has been, for me, it has been so much more than just a platform, it\'s been a partnership."',
    ),
    byline: gettext('Angela Gonzalez, General Manager'),
};

export const GILROY_GARLIC_FESTIVAL = {
    imagePath: 'brand-logos/garlic-festival',
    quote: gettext(
        '"There is no better team on the ground during our event than the Eventbrite staff members who ensure everything runs smoothly and that we have a great event.  The work Eventbrite does is HEROIC."',
    ),
    byline: gettext('Brian Bowe, Executive Director'),
};

export const RHYTHM_AND_VINES = {
    imagePath: 'brand-logos/rhythm',
    quote: gettext(
        '"Eventbrite gives us a robust, world class event technology platform that truly puts the power in my hands."',
    ),
    byline: gettext('Kyle Bell, Marketing & Partnerships Manager'),
};

export const BOTTLE_SHOP_CONCEPTS = {
    imagePath: 'brand-logos/bottle-shop',
    quote: gettext(
        '"We\'ve virtually doubled our numbers since 2013. Eventbrite has been with us the whole way."',
    ),
    byline: gettext('Dan Sims, Event Director'),
};

export const THICK_AS_THIEVES = {
    imagePath: 'brand-logos/thieves',
    quote: gettext(
        '"Eventbrite\'s live reporting has made a huge difference to our business. We\'ve been able to boost sales while actually saving money on marketing."',
    ),
    byline: gettext('Damon Walsh, Events & Marketing Manager'),
};

export const BEYOND_THE_VALLEY = {
    imagePath: 'brand-logos/valley',
    quote: gettext(
        '"Eventbrite brings our checkout to where our fans already are, rather than that the other way around. This takes our promotional efforts to the next level."',
    ),
    byline: gettext('Christian Serrao, Director'),
};

export const LOVES_DATA_CONFERENCE = {
    imagePath: 'brand-logos/loves-data',
    quote: gettext(
        '"Eventbrite\'s system provides valuable insights through its reporting tools, and simply saves us a lot of time."',
    ),
    byline: gettext('Benjamin Mangold, Director of Digital & Analytics'),
};

export const TED_X_MELBOURNE = {
    imagePath: 'brand-logos/tedx',
    quote: gettext(
        '"With Eventbrite, I can get details about our community that I can\'t get anywhere else."',
    ),
    byline: gettext('Jon Yeo, Curator'),
};

export const BEER_INCIDER = {
    imagePath: 'brand-logos/beer-in-cider',
    quote: gettext(
        '"Technology just needs to work and Eventbrite does, no issues."',
    ),
    byline: gettext('Martin Keetels, Founder'),
};

export const ARC_FOR_UNSW = {
    imagePath: 'brand-logos/UNSW',
    quote: gettext(
        '"Now that we understand what specific student identity is coming to our events, we can market them better, and we\'ve seen our conversion rates improve because of this."',
    ),
    byline: gettext('Shelley Valentine, Director of Student Services'),
};

export const YAH_YAHS = {
    imagePath: 'brand-logos/yahyahs',
    quote: gettext(
        '"Eventbrite’s product is leading the market. We wanted to align ourselves with a ticketing partner that is moving in the right direction the fastest, and Eventbrite is constantly innovating to achieve that goal."',
    ),
    byline: gettext('Darve Smith, Director'),
};

export const BITS_AND_PRETZELS = {
    imagePath: 'brand-logos/bits',
    quote:
        '"Mit Eventbrite können wir einen Anmeldeprozess gewährleisten, der auf allen Endgeräten perfekt funktioniert und in zwei Schritten abgeschlossen ist."',
    byline: gettext(
        'Bernd Storm, Felix Haas, Andreas Bruckschlögl, Co-Founder',
    ),
};

export const BITS_AND_PRETZELS_DETAIL = {
    imagePath: 'brand-logos/bits',
    quote:
        '"Mit Eventbrite können wir einen Anmeldeprozess gewährleisten, der auf allen Endgeräten perfekt funktioniert und in zwei Schritten abgeschlossen ist. Anmeldung, Zahlung, die Ticketspeicherung über die App und der Einlass – all das brauchen wir für eine Veranstaltung wie diese und bekommen es hier aus einer Hand."',
    byline: gettext(
        'Bernd Storm, Felix Haas, Andreas Bruckschlögl, Co-Founder',
    ),
};

export const TECH_OPEN_AIR = {
    imagePath: 'brand-logos/toa',
    quote:
        '"Eventbrite ist ein zuverlässiger Partner und hilft neben der technischen Funktionalität, wie dem Payment-Processing, auch mit Customer Support."',
    byline: gettext('Niko Woischnik, Founder'),
};

export const TECH_OPEN_AIR_DETAIL = {
    imagePath: 'brand-logos/toa',
    quote:
        '"Eventbrite ist ein zuverlässiger Partner und hilft neben der technischen Funktionalität, wie dem Payment-Processing, auch mit Customer Support. Zudem hat uns Eventbrite in den letzten Jahren großartig in der technischen Handhabung der Satelliten-Events geholfen."',
    byline: gettext('Niko Woischnik, Founder'),
};

export const INTERATIONAL_GAMES_WEEK = {
    imagePath: 'brand-logos/games',
    quote:
        '"Dadurch, dass wir und auch die einzelnen Veranstalter sehr gerne mit Eventbrite zusammenarbeiten, können wir alle auf dasselbe Ticketing-System zurückgreifen. Die Webseitenintegration ist einheitlich, die Code-Systeme sind einheitlich, ebenso das Look & Feel. Die Partnerschaft zwischen Eventbrite und der #gamesweekberlin ist sozusagen ein vereinheitlichendes Bindeglied zwischen der bunten Vielfalt der Events."',
    byline: gettext('Michael Liebe, Founder'),
};

export const CHESS_BOXING = {
    imagePath: 'brand-logos/chess',
    quote:
        '“Die Analysemöglichkeiten und eingebundene Tools, wie Survey Monkey oder Mailchimp, sind für uns Gold wert."',
    byline: gettext('Iepe Rubingh, Founder'),
};

export const XLETIX = {
    imagePath: 'brand-logos/xletix',
    quote:
        '"Wir haben uns sehr genau informiert, welche Lösungen es gibt und uns schließlich aus mehreren Gründen für Eventbrite entschieden: Die Teilnehmer können ihre Tickets vom Computer, dem Handy oder einem Tablet bestellen und haben verschiedene sichere und schnelle Zahlungsmöglichkeiten. Außerdem behalten wir mit der Eventbrite Veranstalter App auch bei mehreren Tausend Teilnehmern, die auf einer XLETIX Challenge in kurzer Zeit einchecken, den Überblick."',
    byline: gettext('Jannis Bandorski, CEO'),
};

export const FUNDACION_ELEGI_SONREIR = {
    imagePath: 'brand-logos/elegi',
    quote:
        '"Eventbrite me ha ayudado a difundir mis eventos, y me facilita varios medio de pago para los participantes."',
    byline: 'Milagros Cisnero, Secretaria',
};

export const CONVENCIONES_WALKERS = {
    imagePath: 'brand-logos/walker',
    quote:
        '"Eventbrite permite acercarnos al publico que no llega hasta un punto de venta de entradas,siendo una herramienta espectacular!"',
    byline: 'Leonardo Escobar, Director',
};

export const DROVET = {
    imagePath: 'brand-logos/drovet',
    quote:
        '"Eventbrite es práctico y confiable a la hora de gestionar los asistentes a un evento y lograr difusión."',
    byline: 'Alvaro Mariezcurrena, Comunicación y MKT',
};

export const ASISTEM_RRHH = {
    imagePath: 'brand-logos/assistem',
    quote:
        '"Eventbrite me da todo lo que necesito para gestionar el evento, inscripción, acreditación, forma de pago!"',
    byline: 'Daniel D`Agostino, Gerente de Marketing',
};

export const FUNDACION_MEDIAR = {
    imagePath: 'brand-logos/mediar',
    quote:
        '"Es una herramienta excelente para organizar tu evento, te ahorra mucho tiempo y trabajo."',
    byline: 'Leonardo Otarán, Presidente',
};

export const CENTRO_COMERICAL = {
    imagePath: 'brand-logos/ccia',
    quote:
        '"El sistema me permitio tener conocimiento de los asistentes al evento con aticipación y la acreditación es muy agil."',
    byline: 'Sebastian González, Gerente',
};

export const HERNAN_CASCIARI = {
    imagePath: 'brand-logos/hernan',
    quote:
        '"Siempre me pasa que lanzo la venta y se venden rápidamente unos 300 lugares. Prefiero usar herramientas como Eventbrite que me sirven para poder ahorrar tiempo y optimizarlo."',
    byline: 'Hernán Casciari, Actor y Escritor',
};

export const SB_CONGRESOS = {
    imagePath: 'brand-logos/silvana',
    quote:
        '"Eventbrite nos ha sido de gran ayuda al momento de cobrar las inscripciones en el exterior y realizar campañas de email marketing. La base de datos que genera es muy prolija y ordenada."',
    byline: 'Silvana Biagiotti, Directora Ejecutiva',
};

export const PAYONEER = {
    imagePath: 'brand-logos/payoneer',
    quote:
        '"Eventbrite es una manera fácil para que nuestros participantes se inscriban, impriman su ticket y se acrediten rápidamente para ingresar al salón el día del evento. Es ideal y nos ha dado muy buenos resultados."',
    byline: 'Diego Glatzel, Embajador en Argentina',
};

export const TMX = {
    imagePath: 'brand-logos/tmx',
    quote:
        '"Es una herramienta que nos ha dado flexibilidad y nos permite tener el control de las inscripciones, las finanzas, las transferencias, los deslindes de responsabilidad, etc. Además de poder inscribir personas fuera del país."',
    byline: 'Mariano Alvalez, Diretor',
};

export const OPEN_SHIMANO = {
    imagePath: 'brand-logos/shimano',
    quote:
        '"Eventbrite simplifica todo lo relacionado a la recolección de datos y al cobro de las inscripciones. En los últimos años caso el 100% de los competidores se han inscripto a través de la plataforma."',
    byline: 'Martín Cepi Raffo, Coordinador',
};

export const CONAACUP = {
    imagePath: 'brand-logos/conaacup',
    quote:
        '"Trabalho com evento há algum tempo, já usei várias ferramentas para administração de bilhetes e pagamentos, mas a Eventbrite é a mais completa. Estou gostando muito, a ferramenta já está bem madura."',
    byline: 'Marcelo Rocha, Diretor',
};

export const FORRO_DA_LUA_CHEIA = {
    imagePath: 'brand-logos/forro',
    quote:
        '"O check-in é muito prático, não teve nenhum erro de leitura. Foi tudo muito rápido e tranquilo."',
    byline: 'Tiago Machado, Diretor',
};

export const SENSEDIA = {
    imagePath: 'brand-logos/sensedia',
    quote:
        '"A plataforma da Eventbrite está nos ajudando a elevar o nível do nosso evento, o APIX, com um suporte muito efetivo, venda consultiva e um credenciamento sensacional, que nos dá segurança para crescer a cada ano!"',
    byline: 'Eike Malavasi, Diretor',
};

export const TRIANONS = {
    imagePath: 'brand-logos/trianons',
    quote:
        '"Poder criar e monetizar meus eventos ficou bem mais fácil depois que comecei a utilizar a Eventbrite. A ferramenta foi criada pensando em soluções."',
    byline: 'Juliano Kimura, Fundador',
};

export const COMUNIDADE_DAS_NACOES = {
    imagePath: 'brand-logos/nacoes',
    quote:
        '"A Comunidade das Nações encontrou na Eventbrite a melhor solução para organizar a parte financeira e a própria gestão do evento. Desde a facilidade de criar modalidades diferentes de ingressos, até o check-in dos convidados pelo aplicativo - que reduz muito as filas na entrada. Estamos muito felizes com essa parceria."',
    byline: 'Anderson Sousa, Líder Ministerial Tecnologia',
};

export const CASA_COMIGO = {
    imagePath: 'brand-logos/casa',
    quote:
        '"A Eventbrite é uma grande parceira, o atendimento ao cliente é ótimo e a plataforma é simples e fácil de usar!"',
    byline: 'Fernanda Toth, Fundadora',
};

export const NEW_ME = {
    imagePath: 'brand-logos/newme',
    quote:
        '"A parceria entre a Eventbrite e a Escola New Me está sendo sensacional. O suporte é sempre rápido e ágil e as possibilidades de divulgação e relatórios estão fazendo muita diferença para a gente."',
    byline: 'Ana Carolina Gismonti, Fundadora',
};

export const ZUM_BRAZIL_EVENTOS = {
    imagePath: 'brand-logos/zum',
    quote:
        '"A Eventbrite nos surpreendeu muito positivamente pela facilidade de uso da plataforma. Antes usávamos muitos processos manuais (planilhas em excel, cobranças manuais, etc) e a solução da Eventbrite eliminou esses processos burocráticos de uma forma muito positiva, amigável e fácil."',
    byline: 'Emerson Moraes, Diretor',
};

export const ABRADI_SP = {
    imagePath: 'brand-logos/abradi',
    quote:
        '"Tivemos total apoio da equipe da Eventbrite na capacitação do nosso staff e rápido retorno na resolução das intercorrências. Sem dúvida, recomendamos o uso da ferramenta como plataforma para a administração e para a promoção de eventos."',
    byline: 'Paulo Centenaro Filho, Diretor',
};

export const SOCIAL_MEDIA_WEEK_SP = {
    imagePath: 'brand-logos/socialmediaweek',
    quote:
        '"A integração da Eventbrite com redes sociais faz com que cada inscrito amplie a divulgação do evento. Além da venda de ingressos, eles possuem vários recursos interessantes de comunicação para o meu evento."',
    byline: 'Edney Souza, Curador',
};

export const SUPERLOGICA = {
    imagePath: 'brand-logos/superlogica',
    quote:
        '"A plataforma da Eventbrite nos surpreendeu. Foi a escolhida para fazer a gestão dos mais de 100 eventos. Com ela, conseguimos a robustez e a facilidade necessárias para ficarmos tranquilos e focarmos no que importa. O atendimento ágil e preciso também é um fator importante - nunca ficamos na mão."',
    byline: 'Carlos Eduardo Moura, Diretor',
};

export const GFNY = {
    imagePath: 'brand-logos/gfny',
    quote:
        '"A Eventbrite é uma ferramenta fácil de usar por administradores de eventos e possui recursos não só no desktop, mas no mobile. Podemos acompanhar as vendas em tempo real e esclarecer prontamente as dúvidas dos inscritos. Um suporte personalizado torna a dinâmica de inscrição muito eficiente para todas as partes envolvidas. A Eventbrite atende às nossas necessidades e certamente contribui para o sucesso das nossas vendas."',
    byline: 'Luísa Jucá, Sócia',
};

export const PLUS_NETWORK = {
    imagePath: 'brand-logos/plus',
    quote:
        '"Na nossa busca incansável para otimizar a experiência dos fãs dos conteúdos que produzimos, a Eventbrite se mostrou uma poderosa aliada desde os primeiros contatos. Estamos empolgados com as possibilidades que essa parceria trará para nós e nosso público!"',
    byline: 'André Vaccaro, Gerente de Operações',
};

export const QUEREMOS = {
    imagePath: 'brand-logos/queremos',
    quote:
        '"A parceria do Queremos com a Eventbrite agiliza muito nosso processo de venda de ingressos. Tanto pelo atendimento super rápido e preciso, mas também pelas ferramentas. Estamos cada vez mais animados com as possibilidades que a Eventbrite nos tem dado e assim podemos focar no nosso lado da história."',
    byline: 'Felipe Continentino, Co-Fundador',
};
